module.exports = __webpack_public_path__ + "img/64.3bcdf176.jpg";